import React, { useEffect, useState } from 'react';
import { X as XIcon } from 'lucide-react';
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setOpenModal(null);
      }
    };
    if (openModal) {
      window.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [openModal]);
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      setOpenModal(null);
    }
  };
  return <>
      <footer className="py-8 px-4 text-center text-sm text-brand-charcoal/50 bg-brand-cream" data-id="element-23">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-24">
          <p data-id="element-25">
            © {new Date().getFullYear()} The Snap-Back Blueprint. All rights
            reserved.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-26">
            <button onClick={() => setOpenModal('privacy')} className="hover:text-brand-charcoal underline underline-offset-4 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-sage/50 rounded" data-id="element-27">
              Privacy Policy
            </button>
            <button onClick={() => setOpenModal('terms')} className="hover:text-brand-charcoal underline underline-offset-4 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-sage/50 rounded" data-id="element-28">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      {openModal && <div className="fixed inset-0 bg-brand-charcoal/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 sm:p-6" onClick={handleBackdropClick} role="dialog" aria-modal="true" data-id="element-29">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[85vh] flex flex-col relative" data-id="element-30">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-brand-cream shrink-0" data-id="element-31">
              <h2 className="text-2xl font-bold font-heading text-brand-charcoal" data-id="element-32">
                {openModal === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
              </h2>
              <button onClick={() => setOpenModal(null)} className="p-2 text-brand-charcoal/50 hover:text-brand-charcoal hover:bg-brand-cream rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-brand-sage/50" aria-label="Close modal" data-id="element-33">
                <XIcon className="w-6 h-6" data-id="element-34" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="p-6 overflow-y-auto text-brand-charcoal/80 space-y-6 text-left leading-relaxed" data-id="element-35">
              {openModal === 'privacy' ? <>
                  <section data-id="element-36">
                    <h3 className="text-lg font-bold text-brand-charcoal mb-2" data-id="element-37">
                      1. Information We Collect
                    </h3>
                    <p data-id="element-38">
                      We collect information you provide directly to us when you
                      make a purchase, sign up for our newsletter, or interact
                      with our services. This may include your name, email
                      address, payment information, and any other details you
                      choose to provide.
                    </p>
                  </section>
                  <section data-id="element-39">
                    <h3 className="text-lg font-bold text-brand-charcoal mb-2" data-id="element-40">
                      2. How We Use Your Information
                    </h3>
                    <p data-id="element-41">
                      We use the information we collect to process your
                      transactions, deliver the digital products you requested,
                      send you technical notices, updates, security alerts, and
                      support messages. We may also use your information to
                      communicate with you about products, services, offers, and
                      events.
                    </p>
                  </section>
                  <section data-id="element-42">
                    <h3 className="text-lg font-bold text-brand-charcoal mb-2" data-id="element-43">
                      3. Cookies and Tracking Technologies
                    </h3>
                    <p data-id="element-44">
                      We use cookies and similar tracking technologies to track
                      the activity on our service and hold certain information.
                      Cookies are files with a small amount of data which may
                      include an anonymous unique identifier. You can instruct
                      your browser to refuse all cookies or to indicate when a
                      cookie is being sent.
                    </p>
                  </section>
                  <section data-id="element-45">
                    <h3 className="text-lg font-bold text-brand-charcoal mb-2" data-id="element-46">
                      4. Third-Party Services
                    </h3>
                    <p data-id="element-47">
                      We may employ third-party companies and individuals to
                      facilitate our service, provide the service on our behalf,
                      perform service-related services, or assist us in
                      analyzing how our service is used. These third parties
                      have access to your personal data only to perform these
                      tasks on our behalf and are obligated not to disclose or
                      use it for any other purpose.
                    </p>
                  </section>
                  <section data-id="element-48">
                    <h3 className="text-lg font-bold text-brand-charcoal mb-2" data-id="element-49">
                      5. Data Security
                    </h3>
                    <p data-id="element-50">
                      The security of your data is important to us, but remember
                      that no method of transmission over the Internet, or
                      method of electronic storage is 100% secure. While we
                      strive to use commercially acceptable means to protect
                      your personal data, we cannot guarantee its absolute
                      security.
                    </p>
                  </section>
                </> : <>
                  <section data-id="element-51">
                    <h3 className="text-lg font-bold text-brand-charcoal mb-2" data-id="element-52">
                      1. Acceptance of Terms
                    </h3>
                    <p data-id="element-53">
                      By accessing and using this website and purchasing our
                      digital products, you accept and agree to be bound by the
                      terms and provision of this agreement. In addition, when
                      using these particular services, you shall be subject to
                      any posted guidelines or rules applicable to such
                      services.
                    </p>
                  </section>
                  <section data-id="element-54">
                    <h3 className="text-lg font-bold text-brand-charcoal mb-2" data-id="element-55">
                      2. Intellectual Property
                    </h3>
                    <p data-id="element-56">
                      All content included on this site, such as text, graphics,
                      logos, images, digital downloads, and video content, is
                      the property of The Snap-Back Blueprint or its content
                      suppliers and protected by international copyright laws.
                      You may not reproduce, distribute, or transmit any part of
                      this material without prior written permission.
                    </p>
                  </section>
                  <section data-id="element-57">
                    <h3 className="text-lg font-bold text-brand-charcoal mb-2" data-id="element-58">
                      3. Refund Policy (7-Day Guarantee)
                    </h3>
                    <p data-id="element-59">
                      We stand behind our products with a 100% "Mom-Joy"
                      Guarantee. If you are not completely satisfied with your
                      purchase, you may request a full refund within 7 days of
                      your original purchase date. Upon processing your refund,
                      your access to the digital materials will be revoked.
                    </p>
                  </section>
                  <section data-id="element-60">
                    <h3 className="text-lg font-bold text-brand-charcoal mb-2" data-id="element-61">
                      4. Medical Disclaimer
                    </h3>
                    <p data-id="element-62">
                      The content provided in The Snap-Back Blueprint is for
                      informational and educational purposes only and is not
                      intended as medical advice. Always consult with a
                      qualified healthcare professional before beginning any new
                      exercise or nutrition program, especially during the
                      postpartum period.
                    </p>
                  </section>
                  <section data-id="element-63">
                    <h3 className="text-lg font-bold text-brand-charcoal mb-2" data-id="element-64">
                      5. Limitation of Liability
                    </h3>
                    <p data-id="element-65">
                      In no event shall The Snap-Back Blueprint, nor its
                      directors, employees, partners, agents, suppliers, or
                      affiliates, be liable for any indirect, incidental,
                      special, consequential or punitive damages, including
                      without limitation, loss of profits, data, use, goodwill,
                      or other intangible losses, resulting from your access to
                      or use of or inability to access or use the service.
                    </p>
                  </section>
                </>}
            </div>

            {/* Footer */}
            <div className="p-6 border-t border-brand-cream shrink-0 bg-brand-cream/30 rounded-b-2xl" data-id="element-66">
              <button onClick={() => setOpenModal(null)} className="w-full py-3 px-4 bg-brand-charcoal text-white rounded-xl font-bold hover:bg-brand-charcoal/90 transition-colors focus:outline-none focus:ring-4 focus:ring-brand-charcoal/20" data-id="element-67">
                Close
              </button>
            </div>
          </div>
        </div>}
    </>;
}